import axios from "axios";
import { keycloak } from "../../../../lib/keycloak";
import { CompanyCenterCreateRequestDTO, CompanyCenterDTO, CompanyCenterUpdateRequestDTO, FindAllCompanyCentersResponseDTO, FindAllFiltersCompanyCentersDTO } from "./dto";
import { CompanyCenterService } from "./service";

export class CompanyCenterServiceImpl implements CompanyCenterService {
    public createCompanyCenter(data: CompanyCenterCreateRequestDTO): Promise<number> {
        return axios.post("/api/company-center",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public updateCompanyCenter(id: string, data: CompanyCenterUpdateRequestDTO): Promise<void> {

        return axios.put("/api/company-center/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public getCompanyCenters(filters: FindAllFiltersCompanyCentersDTO): Promise<FindAllCompanyCentersResponseDTO> {
        return axios.get("/api/company-center", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page,
                order: filters.order,
                sort: filters.sort,
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public getCompanyCenterById(id: string): Promise<CompanyCenterDTO> {
        return axios.get("/api/company-center/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public deleteCompanyCenter(id: string): Promise<void> {
        return axios.delete("/api/company-center/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "DELETE",
            }
        }).then((response) => response.data)
    }

    public removeCompanyCenter(id: string): Promise<void> {
        return axios.put("/api/company-center/remove/" + id,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}
